export default {"src":"/_next/static/media/trust_icon.f9432b68.svg","height":45,"width":45,"blurWidth":0,"blurHeight":0};